<script lang="ts">
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';

  import { onMount, onDestroy, createEventDispatcher } from 'svelte';

  dayjs.extend(utc);

  const dispatch = createEventDispatcher();

  export let expiresAt: string;
  export let showExpiredLabel = false;
  export let emitExpiredEventOnFirstTime = false;

  let expiresAtLabel = '&nbsp;';
  let isExpirable = false;
  let intervalId: NodeJS.Timeout;

  const expirationTime = dayjs.utc(expiresAt).diff(dayjs.utc(), 'hours');

  function calculateCountdown() {
    const endDate = dayjs.utc(expiresAt);
    const now = dayjs.utc();

    const diffInSeconds = endDate.diff(now, 'seconds');
    const hours = Math.floor((diffInSeconds % (60 * 60 * 24)) / (60 * 60));
    const minutes = Math.floor((diffInSeconds % (60 * 60)) / 60);
    const seconds = Math.floor(diffInSeconds % 60);

    return `${hours.toString().padStart(2, '0')}h:${minutes.toString().padStart(2, '0')}m:${seconds.toString().padStart(2, '0')}s`;
  }

  function startCountdown() {
    intervalId = setInterval(() => {
      const newExpiresAtLabel = calculateCountdown();

      if (newExpiresAtLabel === '00h:00m:00s') {
        if (showExpiredLabel) {
          isExpirable = true;
        }

        expiresAtLabel = showExpiredLabel ? 'Expired' : null;
        
        clearInterval(intervalId);
        dispatch('expired');

        return;
      }

      expiresAtLabel = `Expire in <span>${newExpiresAtLabel}</span>`;
    }, 1000);
  }

  onMount(() => {
    if (dayjs.utc().isAfter(dayjs.utc(expiresAt))) {
      if (emitExpiredEventOnFirstTime) dispatch('expired');

      if (showExpiredLabel) {
        isExpirable = true;
      }

      expiresAtLabel = showExpiredLabel ? 'Expired' : null;

      return;
    }

    if (expirationTime <= 48) { // 48 hours
      expiresAtLabel = `Expire in <span>${calculateCountdown()}</span>`;
      startCountdown();

      return;
    }

    expiresAtLabel = `Expire on ${dayjs.utc(expiresAt).format('MMM DD, YYYY')}`;
  });

  onDestroy(() => {
    if (intervalId) clearInterval(intervalId);
  });
</script>

{#if expiresAtLabel}
<p class="twm-expiring-countdown" class:twm-expiring-countdown--expirable={isExpirable}>
  {@html expiresAtLabel}
</p>
{/if}

<style lang="scss">
  .twm-expiring-countdown {
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.02em;
    color: #1A1D26;

    &--expirable,
    > :global(span) {
      color: #E31616;
    }
  }
</style>
